import {
  CallPageType,
  CallStatusType,
} from '../interfaces/call-page.interface';

export const CALL_PAGE_TYPE = {
  MINIMIZED: 'minimized',
  FULL: 'full',
  HIDDEN: 'hidden',
} as { [key: string]: CallPageType };

export const CALL_PAGE_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  OUTBOUND: 'outbound',
  INBOUND: 'inbound',
  WRAPUP: 'wrapup',
} as { [key: string]: CallStatusType };

export const SEARCH_DEBOUNCE_MS = 350;

export const PAUSE_RECORDING_FEATURE_FLAG = 'DisableDynamics365PauseRecording';
